<script lang="ts" setup>
import { useReCaptcha } from 'vue-recaptcha-v3'
import { useConfigStore } from 'stores/config'
import CookieConsentDialog from 'components/dialogs/CookieConsentDialog.vue'
import { handleVisibilityChange, forceUpdateCheck } from '../src-pwa/register-service-worker'
import { initAnalyticsUserProperties } from 'src/composables/useAnalytics'

const configStore = useConfigStore()
window.addEventListener('beforeinstallprompt', (e) => {
  // Prevent the default mini-infobar from appearing
  e.preventDefault()
  // Stash the event for later use
  configStore.setBeforeInstallEvent(e)
})

// Handle visibility changes for asset update checks
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) {
    // Page became visible, check for updates
    handleVisibilityChange()
  }
})

// Optional: Force update check on app focus (additional trigger)
window.addEventListener('focus', () => {
  forceUpdateCheck()
})

const recaptcha = useReCaptcha()
void recaptcha?.recaptchaLoaded().then(() => recaptcha?.instance.value?.hideBadge())

// Initialize and keep GA4 user properties in sync
initAnalyticsUserProperties()
</script>

<template>
  <router-view />

  <CookieConsentDialog />
</template>
